<template>
  <div>
    <section-pricing />
  </div>
</template>
<script>

import SectionPricing from "@/components/sections/Pricing";

export default {
  name: "Pricing",
  components: {SectionPricing},
}

</script>
